<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm05"><a id="page_7"></a><strong>Contents</strong></h2>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm06#ch00_fm06">Foreword</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm07#ch00_fm07">Introduction</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch00_fm08#ch00_fm08">Publisher’s Note</a></p>
<p class="toc1"><a class="nounder" href="#/xhtml/ch01#ch01">Chapter 1: Everything You Ever Wanted to Ask About Celiac Disease</a></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch02#ch02" title="Link target outside of Sample">Chapter 2: All About Gluten-Free Diets</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch03#ch03" title="Link target outside of Sample">Chapter 3: Children and Celiac Disease</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch04#ch04" title="Link target outside of Sample">Chapter 4: The Gluten-Free Kitchen</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch05#ch05" title="Link target outside of Sample">Chapter 5: Preparing Everyday Gluten-Free Meals</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch06#ch06" title="Link target outside of Sample">Chapter 6: Delightful Gluten-Free Recipes</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch07#ch07" title="Link target outside of Sample">Chapter 7: Gluten-Free for All Occassions</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch08#ch08" title="Link target outside of Sample">Chapter 8: Tips for Living Every Day on a Gluten-Free Diet</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch09#ch09" title="Link target outside of Sample">Chapter 9: Resource Guide</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch10_index#ch10_index" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch11_abt#ch11_abt" title="Link target outside of Sample">About the Author</span><a id="page_8"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm05.vue?fbea6e0e